import * as React from 'react';
import Select from 'react-select';

interface JobType {
  id: number;
  title: string;
}

interface Props {
  job_types: JobType[];
  selected: number[];
}

const ProfileJobTypesSelect: React.FC<Props> = ({ job_types, selected }) => {
  const [selectedJobTypes, setSelectedJobTypes] = React.useState<number[]>(selected || []);

  // Create options for react-select
  const jobTypeOptions = job_types.map(jobType => ({
    value: jobType.id,
    label: jobType.title
  }));

  // Create hidden inputs for the form submission
  const hiddenInputs = selectedJobTypes.map(id => (
    <input
      key={id}
      type="hidden"
      name="profile[job_type_ids][]"
      value={id}
    />
  ));

  // Add an empty input to ensure the array is sent even if empty
  hiddenInputs.push(
    <input
      key="empty"
      type="hidden"
      name="profile[job_type_ids][]"
      value=""
    />
  );

  const customStyles = {
    option: (styles: any) => {
      return {
        ...styles,
      }
    },
    multiValueLabel: (styles: any) => {
      return {
        backgroundColor: '#176fc9',
        color: 'white',
        borderRadius: '5px 0 0 5px',
        paddingLeft: 8,
        paddingTop: 5,
        paddingBottom: 5,
        paddingRight: 3,
      }
    },
    multiValueRemove: (styles: any) => {
      return {
        ...styles,
        backgroundColor: '#176fc9',
        color: 'white',
        borderRadius: '0 5px 5px 0',
        paddingRight: 5,
        paddingLeft: 4,
        marginLeft: -1,
      }
    },
  };

  return (
    <div>
      {hiddenInputs}
      <Select
        options={jobTypeOptions}
        isMulti
        value={jobTypeOptions.filter(option => selectedJobTypes.includes(option.value))}
        onChange={(selectedOptions) => {
          const values = (selectedOptions || []).map(option => option.value);
          setSelectedJobTypes(values);
        }}
        styles={customStyles}
        placeholder="Search for job types..."
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default ProfileJobTypesSelect;
